module.exports = __webpack_public_path__ + "fonts/Inter-600-greek-ext38.318d4ba.woff2";